import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'footerNav',
  title: 'Footer Nav',
  type: 'document',
  fields: [
    defineField({
      name: 'items',
      type: 'array',
      maxItems: 3,
      title: 'Nav Groups',
      of: [{ type: 'navGroupItem' }],
    }),
  ],
  preview: {
    prepare() {
      return {
        title: `Footer Navigation`,
        subtitle: ``,
      }
    },
  },
})